import axios from "axios";
import { getIdToken } from "./authSession";
import { responseSuccessInterceptor, responseErrorInterceptor } from "./errorHandler";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

axiosInstance.interceptors.request.use(async (config) => {
  try {
    config.headers.Authorization = `Bearer ${await getIdToken()}`;
    return config;
  } catch (err) {
    // No sign out here: Amplify v6 clears the tokens itself when the session can't be renewed
    // (that surfaces as NO_CURRENT_USER and RequireAuth sends the user to the login), and keeps
    // them on transient errors such as a dropped connection so a later request can retry.
    $log.error(err);
    return Promise.reject(err);
  }
});

// Add response interceptors for centralized error handling
axiosInstance.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default axiosInstance;
